import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';

export const baseURI = 'configuracion/cargos-vehiculares/';

/**
 * GET Cargos Vehiculares
 * @param {Object} params
 * @returns {Promise<Array<object>>}
 */
export const getCargosVehiculares = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Cargo Vehicular
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getCargoVehicular = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Cargo Vehicular
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postCargoVehicular = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Cargo Vehicular
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchCargoVehicular = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Cargo Vehicular
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteCargoVehicular = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
